import { Pipe, PipeTransform } from '@angular/core';

import { arquivosExtensoes } from '../arquivo-extensao';

@Pipe({
    name: 'arquivoExtensao'
})
export class ArquivoExtensaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = arquivosExtensoes.findIndex(extensao => extensao.id === value);
        if (index > -1) {
            return arquivosExtensoes[index].nome;
        }
        return '';
    }
}
